<template>
  <div class="flex box-gap">
    <div class="calculator-box">
      <radio-button
        class="mgb32 w-full"
        v-model="radio"
        :options="[
          { label: $t('calculator.cnode'), value: '2' },
          { label: $t('calculator.nnode'), value: '1' },
        ]"
      />
      <div class="mgb32 w-full">
        <p class="calculator-item-title">{{ $t("calculator.stakeamount") }}</p>
        <div class="calculator-item-input mgb12">
          <el-input
            v-model="stakeAmount"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            placeholder="0"
          >
          </el-input>
          <img src="~assets/img/ONT.png" class="input-logo ont-logo" alt="" />
        </div>
        <div v-if="radio == 2" class="calc-msg">
          {{ $t("calculator.amountMsg1") }}
          {{ $HelperTools.toFinancialVal(leastNum + 1) }}
          ONT
        </div>
        <div v-if="radio == 1" class="calc-msg">
          {{ $t("calculator.amountMsg2") }} 10,000 ONT
        </div>
      </div>
      <div class="mgb40 w-full">
        <p class="calculator-item-title">{{ $t("calculator.reward") }}</p>
        <div class="calculator-item-input">
          <el-input
            v-model="rewardRate"
            oninput="this.value = this.value.replace(/[^0-9]/g, '');"
            placeholder="0"
          />
          <span class="input-logo x-bold">%</span>
        </div>
      </div>
      <button class="calculator-btn" @click="calculator()">
        {{ $t("calculator.calc") }}
      </button>
    </div>
    <calc-result
      :totalRate="this.totalRate"
      :totalAmount="this.totalAmount"
      :feeRate="this.nodeinfo.node_gas_fee_incentive_rate"
      :feeAmount="this.nodeinfo.node_gas_fee_incentive"
      :releasedRate="this.nodeinfo.node_released_ong_incentive_rate"
      :releasedONG="this.nodeinfo.node_released_ong_incentive"
    />
  </div>
</template>

<script>
import RadioButton from "./RadioButon.vue";
import CalcResult from "./CalcResult.vue";
export default {
  name: "calculatorNode",
  components: {
    RadioButton,
    CalcResult
  },
  props: {
    leastNum: {
      type: Number,
    },
    totalmaxAmount: {
      type: Number,
    },
  },
  data() {
    return {
      radio: "2",
      stakeAmount: 0,
      rewardRate: 100,
    };
  },
  computed: {
    nodeinfo() {
      return this.$store.getters.nodeinfo || 0;
    },
    totalRate() {
      const num = parseFloat(this.nodeinfo.node_foundation_bonus_incentive_rate) +
        parseFloat(this.nodeinfo.node_gas_fee_incentive_rate) +
        parseFloat(this.nodeinfo.node_released_ong_incentive_rate);
      if (isNaN(num)) return ''
      return num.toFixed(2) + "%"
    },
    totalAmount() {
      const num = parseFloat(this.nodeinfo.node_foundation_bonus_incentive) +
        parseFloat(this.nodeinfo.node_gas_fee_incentive) +
        parseFloat(this.nodeinfo.node_released_ong_incentive);
      if (isNaN(num)) return
      return num
    }
  },
  methods: {
    calculator() {
      if (this.stakeAmount > this.totalmaxAmount) {
        let amount = this.totalmaxAmount;
        amount = this.$HelperTools.toFinancialVal(amount);
        this.$message({
          message: this.$t("calculator.maxstakeMsg") + amount + " ONT",
          type: "warning",
        });
        return;
      }
      if (this.radio == 2) {
        if (this.stakeAmount <= this.leastNum) {
          let amount = this.leastNum + 1;
          amount = this.$HelperTools.toFinancialVal(amount);
          this.$message({
            message: this.$t("calculator.amountMsg1") + amount + " ONT",
            type: "warning",
          });
          return;
        }
      } else {
        if (this.stakeAmount < 10000) {
          let amount = 10000;
          amount = this.$HelperTools.toFinancialVal(amount);
          this.$message({
            message: this.$t("calculator.amountMsg2") + amount + " ONT",
            type: "warning",
          });
          return;
        }
        if (this.stakeAmount >= this.leastNum) {
          let amount = this.leastNum;
          amount = this.$HelperTools.toFinancialVal(amount);
          this.$message({
            message: this.$t("calculator.amountMsg3") + amount + " ONT",
            type: "warning",
          });
          return;
        }
      }
      let params = {
        init_pos: this.stakeAmount,
        node_proportion: this.rewardRate + "%",
        node_type: this.radio,
      };
      this.$store.dispatch("getNodeInfo", params).then();
    },
  },
};
</script>
<style lang="scss" scoped>
@import './style.scss';
.input-logo {
  position: absolute;
  right: 10px;
  top: 8px;
}
.ont-logo {
  width: 24px;
  height: 24px;
}
</style>
